<template>
  <div v-if="id && !activeTour">
    <button class="btn btn-primary mr-2" v-if="error" @click="fetchInternalImages" :disabled="isLoading">
      <font-awesome-icon icon="spinner-third" v-if="isLoading" spin />
      <span v-else>Load Internal Images &amp; X-Rays</span>
    </button>
    <span class="alert alert-warning" v-if="error">Failed to fetch internal files: {{ error }}</span>
    <span class="text-muted" v-else-if="isFetched">{{ images.length }} internal image(s) found</span>
    <ul class="thumbnail-grid" v-if="images && images.length">
      <li v-for="file in images" :key="file.image_url">
        <a :href="file.image_url">
          <img v-if="file.image_url" :src="file.image_url" /></a>
        <div style="line-height: 0.9em" class="mt-2">
          <small class="text-break d-inline-block">{{ file.name }}</small>
          <small class="text-muted" v-if="file.image_upload_time">
            {{ moment(file.image_upload_time).fromNow() }}</small>
        </div>
        <div class="mt-2">
          <a href="javascript:void(0)" @click="transferImage(file.image_url)">
            <font-awesome-icon icon="plus-circle" class="mr-2" />Add to referral
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { PatientApi } from '@/services'
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  props: ['id', 'referralId'],
  data() {
    return {
      images: [],
      isLoading: false,
      isFetched: false,
      error: '',
    }
  },
  computed: {
    ...mapState('tour', ['activeTour']),
  },
  mounted() {
    if (!this.id || this.activeTour) return
    this.fetchInternalImages()
  },
  methods: {
    async fetchInternalImages() {
      try {
        this.isLoading = true
        this.error = ''
        this.images = await PatientApi.get(`patient-images/${this.id}`)
        this.isFetched = true
      } catch (err) {
        this.error = err
      }
      this.isLoading = false
    },
    async transferImage(image_url) {
      try {
        this.images = await PatientApi.saveRelated(
          `transfer-image`,
          `${this.referralId}`,
          { image_url }
        )
      } catch (err) {
        this.$exception(err)
      }
    },
  },
}
</script>
<style scoped>
.thumbnail-grid {
  margin: 1em 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid: auto-flow / repeat(auto-fit, minmax(200px, 1fr));
  align-items: center;
  grid-gap: 1em;
  gap: 1em;
}
.thumbnail-grid li {
  padding: 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
  background: #f4f4f4;
}
.thumbnail-grid li img {
  max-width: 100%;
}
</style>
